import { render, staticRenderFns } from "./ExpiredLink.vue?vue&type=template&id=6d60eb1c&scoped=true"
import script from "./ExpiredLink.vue?vue&type=script&lang=ts"
export * from "./ExpiredLink.vue?vue&type=script&lang=ts"
import style0 from "./ExpiredLink.vue?vue&type=style&index=0&id=6d60eb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60eb1c",
  null
  
)

export default component.exports